import React from 'react';

export function PricingHeader() {
  return (
    <div className="text-center mb-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        料金プラン
      </h1>
      <p className="text-lg text-gray-600 max-w-2xl mx-auto">
        ビジネスの規模に合わせて最適なプランをお選びください。<br />
        すべてのプランに基本機能が含まれ、作業時間を大幅に削減できます。
      </p>
    </div>
  );
}